module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgBrZKBDYIwEEUPwgBuIGyAG7CBugFOIE6iToBOYJzAEXADGMEN8A5+k9IcpYn+5KVwvftHy0U0VcrUWDV1zAGrKimuaF6y9/LsU8Osya/WfkmwlsyWyZnbgsEKX3GX3AjFR+ZEnrM5SpkzaujCFFhbdAjRjqljq0AuKGM+gQZDXkw/6m8GcowH09N4Dz4kZzILJY3/P0dCyBykaFiaYAUTcS9mOpsmPZ6HiY0U90KJG3XIyUwgUZI2NA6Jpr0b0Awau8OSXIMr8yb/MD3tly+7oDStDl4GEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/printer-1.png
// module id = 2609
// module chunks = 1